import React, { FC } from 'react'
import { CareTeamBundle } from '../../../../../types/FHIRTypes/Bundle'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { isCareTeamBundle } from '../../../../../typeGuards/fhirTypes'
import { CareTeamTable } from '@teschglobal/tg-fhir-react-components'

type CareTeamListProps = {
  careTeamData: CareTeamBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}


const CareTeamList: FC<CareTeamListProps> = ({ careTeamData, handleChangePage, isFetching, totalPages, currentPage }) => {
  if (!isCareTeamBundle(careTeamData)) return null

  const patientCareTeams = careTeamData && careTeamData.entry ? careTeamData.entry.map((careTeam) => careTeam.resource) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {
        careTeamData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{careTeamData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <CareTeamTable
        careTeams={patientCareTeams}
      />
      {
        careTeamData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default CareTeamList